import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnNavService } from "@bndes/bndes-ux4/bn-nav";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import { Subscription } from 'rxjs';
import { ModalidadeGarantiaService } from './features/modalidade_garantia/modalidade-garantia.service';
import { MenuService } from './menu.service';
import { ModalidadeGarantia, TipoEstiloMenuDTO } from './model/modalidade_garantia.model';
import { ModalidadeService } from './shared/services/modalidade.service';
import { RemoverAlertasService } from './shared/services/remover-alertas.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
    public itensMenu$ = [];
    private idSequencial: number = 0;
    subscricoes: Subscription[] = [];
    public estiloMenu: string;
    public menuVisivel: boolean;

    constructor(public removerAlertasService: RemoverAlertasService,
        private usuarioService: BnUsuarioService,
        private modalidadeService: ModalidadeService,
        private bnNavService: BnNavService,
        private titleService: Title,
        private menuService: MenuService,
        private modalidadeGarantiaService: ModalidadeGarantiaService,
        private loadingService: BnLoadingService) {
    }

    public obterTitulo() {
        return this.modalidadeService.modalidadeTitulo$;
    }
    
    public ngOnDestroy() {
        this.subscricoes.forEach(s => s.unsubscribe());
    }
   
    public ngOnInit() {
        this.subscricoes.push(this.modalidadeService.modalidadeTitulo$.subscribe(nomeModalidade => {
            this.titleService.setTitle(nomeModalidade);
            if(nomeModalidade){
                 this.carregarEstiloModalidadeUsuarioLogado(); 
            }
            this.loadingService.liberaTela();
        })); 

        this.usuarioService.usuario$.subscribe((usuario) => {
            if (!usuario) {
                sessionStorage.clear();
                this.estiloMenu='';
                this.menuVisivel = false;
            } 
        });

        this.menuService.itensMenu$.subscribe(itens => {
            this.itensMenu$ = itens;
            this.atualizarIds(this.itensMenu$);
        })
    }

    public carregarEstiloModalidadeUsuarioLogado(){
        return this.modalidadeGarantiaService.buscarModalidade().subscribe (modalidade => {
            this.carregarEstiloModalidade(modalidade);
          });
    }

    public carregarEstiloModalidade(modalidade: ModalidadeGarantia) {
        this.estiloMenu = modalidade.estiloMenu;
        this.menuVisivel = true;
    }

    public atualizarIds(itens: any[]): void {
        for (let item of itens) {
            item.id = item.id || this.idSequencial++;
            if (item.subitem && item.subitem.length > 0) {
                this.atualizarIds(item.subitem);
            }
        }
    }
}
